module.exports = __webpack_public_path__ + "images/help/video-docs-small-89937b1aefc0ebffa18712f578d4dd6c.png";